module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag",
    class: {
      deletable: _vm.deletable
    },
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.tag.name))]), (_vm.deletable) ? _c('span', {
    staticClass: "delete-button",
    on: {
      "click": _vm.removeTag
    }
  }, [_vm._v("×")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-286cd230!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tags/tag.vue
// module id = 1054
// module chunks = 1